export const locale = {
    lang: 'pt',
    data: {
      'LOGIN': {
        'AUTENTICACION': {
          'TITULO': 'Autenticação de duas etapas',
          'SUBTITULO': 'Para fornecer maior segurança ao entrar na plataforma, é necessário que você execute a autenticação em duas etapas conforme indicado abaixo',
          'BOTONES': {
            'SIGUIENTE': 'Próximo',
            'ANTERIOR': 'Anterior'
          },
          'PASOS': {
            '1': {
              'TITULO': 'Passo 1',
              'INSTRUCCION': 'Digitalize o código QR com o aplicativo móvel Google Authenticator e clique no botão seguinte',
              'REGISTRADO': 'Foi detectado que seu e-mail já está cadastrado no aplicativo Google Authenticator, não é necessário escanear o código QR novamente, passe para a próxima etapa'
            },
            '2': {
              'TITULO': 'Passo 2',
              'INSTRUCCION': 'Insira a chave fornecida pelo Google Authenticator e clique em próximo ',
              'INPUT': 'Chave obtida',
              'INFOPREVIA': {
                'INFO_1': 'Foi detectado que você já acessou a plataforma deste computador. Não há necessidade de ler o código QR novamente',
                'INFO_2': 'Basta inserir a senha fornecida pelo Google Authenticator para sua conta e clicar em Avançar',
                'INFO_3': 'Se você quiser ler o código QR novamente, clique no botão Anterior',
                'INFO_4': 'Aviso: ao fazer isso, você terá que vincular sua conta ao Google Authenticator novamente',
              }
            },
            '3': {
              'TITULO': 'Resultado',
              'INSTRUCCION': 'Insira a chave obtida do código QR na etapa anterior e clique no botão próximo',
              'VALIDANDO': 'Validando a chave inserida, espere um momento',
              'MAL': 'A chave está incorreta ou expirou, digite a chave novamente e tente novamente',
              'BIEN': 'Você completou com sucesso a autenticação, então você entrará na plataforma'
            },
          }
        },
        'PASSWORD':{
          'AVISO':'Digite seu endereço de e-mail, enviaremos um link para alterar sua senha',
          'BTN':'Enviar email',
          'PLACERHOLDER':'Email address',
          'ERROR':'Não encontramos seu e-mail. Por favor tente um email diferente',
          'TRUE':'O e-mail foi enviado, verifique sua caixa de entrada ou pasta de spam'
        },
        'RESET':{
          'LABEL01':'Por favor ... insira sua nova senha para o usuário:   ',
          'LABEL02':'Senha',
          'LABEL03':'Redigite a senha',
          'BTN':'Change password',
          'ERROR':'Erro, o token não foi encontrado',
          'NOPASSWORDMATCH':'A senha não corresponde',
          'CARACTERES':'Deve ter pelo menos 3 caracteres',
          'SUCCESSCHANGE':'Sua senha foi alterada corretamente'
        },
        'LANDING': {
          'MENSAJE': 'Bem-vindo',
          'NAVEG': ''
          //'NAVEG': 'The use of <a class="linkChrome" href="https://www.google.com/intl/es-419/chrome/" target="blank">Google Chrome</a> browser is recommended'
        },
        'MODALES': {
          'AVISO1': {
            'TITULO': 'Important announcement.',
            'TEXTO': `Caro usuário: <br> <br>
             Fica informado que, para um melhor atendimento, será realizada uma atualização da plataforma Cultural GO para otimizar o seu funcionamento. <br> <br>
             A atualização ocorrerá na <strong> sexta-feira, 23 de julho, a partir das 23h59 até 23h59 no sábado, 24 de julho </strong>. Durante esse período, a plataforma permanecerá inativa. No entanto, as pesquisas atuais permanecerão ativas. <br> <br>`
          }
        },
        'FORM': {
          'FORGOTPASSWORD':'Recuperação de senha',
          'LOGIN':'Entar',
          'TITULO': 'ENTRAR EM SUA CONTA',
          'INPUT':{
            'EMAIL': 'O email',
            'PASSWORD': 'Senha',
            'LANGSEL': 'Escolha um idioma'
          },
          'VAL': {
            'NOTEMAIL': 'E-mail é obrigatório ',
            'INVEMAIL': 'Por favor insira um endereço de e-mail válido ',
            'CARACT_EMA': ' O campo não permite os seguintes caracteres /&¿+#$%([=])*?"<>>:\'',
            // 'PASS': ' Senha requerida ',
            'PASS': 'Senha inválida',
          },
          'SIGNIN': 'GO!',
          'CAMBIALOGO': 'Clique aqui para alterar o logótipo da sua empresa',
          'CARGAOK': 'O logótipo da sua empresa foi carregado correctamente',
          'CARGANULL': 'Ocorreu um erro ao carregar o logótipo da sua empresa',
          'CARGAERROR': 'O formato do ficheiro seleccionado não é o correcto. Apenas são aceites os seguintes formatos: jpg, png, gif'
        }
      },
      'LOGIN-ENCUESTADOR':{
        'FORM': {
          'TITULO': 'INGRESE A SU CUENTA',
          'INPUT':{
            'PASSWORD': 'Password:',
            'LANGSEL': 'Choose a language:',
            'LOGIN': 'Login',
          },

      },
      'INTRO-LOGIN':{
        'TITULO':'INSTRUCTIONS',
        'TEXT1':'Great Place to Work® Institute. welcomes you to answer your work climate survey 100% confidentially',
        'TEXT2':'Confidentiality',
        'TEXT3':'At the Institute:',
        'TEXT4':'we administer, process, statistically analyze responses by organization and area.',
        'TEXT5':'We generate global results that indicate the improvement actions in the organizations climate.',
        'TEXT6':'you wont know the individual responses',
        'TEXT7':'Individual responses are strictly confidential,',
        'TEXT8':'Denuncias y Sugerencias',
         'TEXT9':' Está estrictamente prohibido que:',
         'TEXT10':'se te influencie, penalice o impida de cualquier forma responder libremente la encuesta.',
         'TEXT11':'Ponemos a tu disposición el siguiente correo para hacer denuncias o sugerencias:',
         'TEXT12':'mx_transparencia@greatplacetowork.com',
         'TEXT13':'Instrucciones:',
         'TEXT14':'1. Ingresa tu ',
         'TEXT15':'número de empleado + año de nacimiento.',
         'TEXT16':'2. No dejes espacios en blanco.',
         'TEXT17':'3. Da clic en Iniciar.',
         'TEXT18':'¡Ayúdanos a contestar la encuesta de Great Place to Work® Institute!',
      }

    },
    'LOADING':{
      'TEXT_WELCOM': 'Bem-vindo a CulturalGo',
      'TEXT_CHANGE': 'Carregamento de informação...',
    }
    }
};
